import { render } from "./FollowupAssessmentDiagnosisNew.vue?vue&type=template&id=41c145a8&scoped=true"
import script from "./FollowupAssessmentDiagnosisNew.vue?vue&type=script&lang=js"
export * from "./FollowupAssessmentDiagnosisNew.vue?vue&type=script&lang=js"

import "./FollowupAssessmentDiagnosisNew.vue?vue&type=style&index=0&id=41c145a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c145a8"]])

export default __exports__